import styled from "styled-components";

export const LeadContainer = styled.div<{ isDesktop: boolean }>`
    background-color: #006571;
    padding: 20px;
    color: #fff;
    margin-top: 40px;
    border-radius: ${({ isDesktop }) => (isDesktop ? "16px" : "0px")};
    @media (min-width: 1024px) {
        padding: 64px;
    }
`;

export const LeadTitle = styled.h2`
    margin-bottom: 20px;
`;

export const LeadText = styled.p`
    margin-bottom: 24px;
`;